export default __webpack_public_path__ + "static/media/catalogue.e367cb5f.png";